import React from 'react';
// import moment from 'moment-timezone';

import ReactDOM from 'react-dom';
import DashApp from './dashApp';
import 'antd/dist/antd.css';
import './index.css';

// moment.tz.setDefault('America/New_York');

ReactDOM.render(<DashApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();
